import interactiveService from 'services/InteractiveService';

export default class CrossCoursewareService {

    static _instance;
    // For now, we are only supporting interactive plugins
    getCourseware(interactiveId){
      return interactiveService.getInteractive(interactiveId); 
    }

    static build() {
      if (!CrossCoursewareService._instance) {
        CrossCoursewareService._instance = new CrossCoursewareService();
      }
      return CrossCoursewareService._instance;
    }
}